import { SDUIOnClickHandler } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUITileInstanceRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { SDUITypographyRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { Sizing } from "@faire/web-api--source/indigofair/data/Sizing";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

import { SDUIImageOrIconRenderer } from "../../ImageOrIcon/SDUIImageOrIconRenderer";

export const SDUIButtonTileRenderer = ({
  tileElement,
  loggingData,
}: SDUITileInstanceRendererProps) => {
  const { on_click, button_tile } = tileElement;
  const { title, icon } = button_tile ?? {};
  if (!title || !icon) {
    return null;
  }

  return (
    <SDUIOnClickHandler
      onClickActions={on_click}
      loggingData={loggingData}
      logLegacyClickEvent
      className="flex h-full w-full items-center justify-center"
    >
      <Column>
        <div className="bg-fs-surface-tertiary flex h-[56px] w-[56px] items-center justify-center rounded-full">
          <SDUIImageOrIconRenderer
            imageOrIcon={{
              icon: icon,
              image: undefined,
              image_or_icon_size: Sizing.SIZING_L,
            }}
          />
        </div>
        <Spacer height="2x" />
        <SDUITypographyRenderer textElement={title} loggingData={loggingData} />
      </Column>
    </SDUIOnClickHandler>
  );
};
